module.exports = __webpack_public_path__ + "static/media/button_ritsu8cc8cdcd09d12e7a66c479cd9aad7b52.webp";